"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedFunction = exports.usePrevious = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
var usePrevious = function (value) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
};
exports.usePrevious = usePrevious;
var useDebouncedFunction = function (_a) {
    var changeHandler = _a.changeHandler, delay = _a.delay;
    var destroyed = false;
    (0, react_1.useEffect)(function () {
        return function () {
            destroyed = true;
        };
    }, []);
    var debouncedOnChange = (0, react_1.useCallback)((0, lodash_1.debounce)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!destroyed) {
            changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler.apply(void 0, args);
        }
    }, delay, {
        leading: false,
        trailing: true
    }), []);
    return debouncedOnChange;
};
exports.useDebouncedFunction = useDebouncedFunction;
//# sourceMappingURL=hooks.js.map